import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { ButtonCondensed } from '@companycam/slab-web';

const TokenSuggestions = ({ tokenDefs, onSelect, onCancel }) => {
  const tokenComponents = tokenDefs.map((token) => {
    const suggestionText = token.text.trim();

    return (
      <div
        key={`${token.value}:${suggestionText}`}
        onClick={() => {
          if (token.disabled) {
            return;
          }
          onSelect(token);
        }}
        className="nameSuggestion"
      >
        <div className="nameSuggestionImage">
          <img src={token.imageURL} alt={suggestionText} />
        </div>
        <div className="nameSuggestionTextWrapper">
          <span className="nameSuggestionText">{suggestionText}</span>
          {token.disabled ? (
            <span className="nameSuggestionTextMeta">
              {token.disabledReason}
            </span>
          ) : null}
        </div>
      </div>
    );
  });

  let noResultsComponent = null;
  if (tokenComponents.length === 0) {
    noResultsComponent = (
      <p className="nameSuggestionNone">
        <FormattedMessage
          id="Activity.tokenSuggestions.noMatchingResults"
          defaultMessage="No matching results"
          description="message to the user that is shown when there are no results"
        />
      </p>
    );
  }

  return (
    <div className="nameSuggestionWrapper">
      <span className="nameSuggestionCancel" onClick={onCancel}>
        <ButtonCondensed
          size="small"
          color="subtle"
          icon={{
            name: 'close-circle',
            position: 'before',
          }}
          onClick={onCancel}
        >
          <FormattedMessage id="Common.cancel" />
        </ButtonCondensed>
      </span>
      {tokenComponents}
      {noResultsComponent}
    </div>
  );
};

TokenSuggestions.propTypes = {
  tokenDefs: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default TokenSuggestions;
